// extracted by mini-css-extract-plugin
module.exports = {"content":"Auth_content__28q-8","avatar":"Auth_avatar__3Jqsh"};